export const ICustomNavigatorType = Symbol('ICustomNavigator');
